import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-load-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " NO DETAIL FIELD FOR TYPE : " + _toDisplayString(_ctx.definitionAttributes.type) + " ( " + _toDisplayString(_ctx.definitionAttributes.name) + " ) ", 1))
}